import {
	GET_ACCOUNT_INFO_REQUEST,
	GET_ACCOUNT_INFO_SUCCESS,
	GET_INVOICES_REQUEST,
	GET_INVOICES_SUCCESS,
	UPDATE_ACCOUNT_REQUEST,
	UPDATE_ACCOUNT_SUCCESS,
	UPDATE_ACCOUNT_ERROR,
	EDIT_ACCOUNT_INFO,
	CANCEL_EDIT_ACCOUNT_INFO,
	GET_MY_MEMBERSHIPS_REQUEST,
	GET_MY_MEMBERSHIPS_SUCCESS,
	GET_MY_ORGANIZATIONS_REQUEST,
	GET_MY_ORGANIZATIONS_SUCCESS,
	GET_USERS_INVITATIONS,
	GET_USERS_EVENTS,
	GET_USERS_COMMITTEES,
	GET_USER_COMMITTEE_DETAILS,
	SELECTED_COMMITTEE,
	SELECTED_MEMBER,
	SELECTED_ORGANIZATION,
	CANCEL_MEMBERSHIP_SUBSCRIPTION_REQUEST,
	CANCEL_MEMBERSHIP_SUBSCRIPTION_SUCCESS,
	GET_PAYMENT_REQUEST,
	GET_PAYMENT_SUCCESS,
	CLEAR_PAYMENT,
} from '../../Actions/EndUser/AccountDetailsActions';

const initialState = {
	error: '',
	updating: false,
	getting: true,
	gettingOrganizations: true,
	details: {
		state: {
			id: 0,
			name: ''
		}
	},
	testData: [],
	email: '',
	editting: false,
    myMemberships: [],
	userInvitations:[],
	userEvents:[],
	userCommittees:[],
	committeeDetails:{},
	selectedUserCommittee: {},
	selectedMember: {
		membershipId: null
	},
	loadingInvoices: true,
	cancelAutoRenew: false
};
export const accountDetails = (state = initialState, action) => {
	switch (action.type) {
		case GET_ACCOUNT_INFO_REQUEST:
			return {
				...state,
				getting: true,
				email: action.payload
			};
		case GET_ACCOUNT_INFO_SUCCESS:
			return {
				...state,
				getting: false,
				details: action.payload
			};			
		case GET_INVOICES_REQUEST:
			return {
                ...state,
                loadingInvoices: true
            };
        case GET_INVOICES_SUCCESS:
            return {
                ...state,
                loadingInvoices: false,
                testData: action.payload
            };
		
		case UPDATE_ACCOUNT_REQUEST:
			return {
				...state,
				updating: true,
				error: ""
			};
		case UPDATE_ACCOUNT_SUCCESS:
			return {
				...state,
				editting: false,
				updating: false,
				error: ""
			};
		case UPDATE_ACCOUNT_ERROR:
			return {
				...state,
				updating: false,
				error: action.payload
			};
		case EDIT_ACCOUNT_INFO:
			return {
				...state,
				editting: true
			};
		case CANCEL_EDIT_ACCOUNT_INFO:
			return {
				...state,
				editting: false
			};
		case GET_MY_MEMBERSHIPS_REQUEST:
			return {
				...state,
				getting: true
			};
		case GET_MY_MEMBERSHIPS_SUCCESS:
			return {
				...state,
				getting: false,
				myMemberships: action.payload
			};


		case GET_PAYMENT_REQUEST:
			return {
				...state,
				getting: true
			};
		case GET_PAYMENT_SUCCESS:
			return {
				...state,
				getting: false,
                paymentMethod: action.payload
			};
		case CLEAR_PAYMENT:
			return {
				...state,
				paymentMethod: null
			};
		case GET_MY_ORGANIZATIONS_REQUEST:
			return {
				...state,
				gettingOrganizations: true
			};
		case GET_MY_ORGANIZATIONS_SUCCESS:
			return {
				...state,
				gettingOrganizations: false,
				myOrganizations: action.payload
			};
		case GET_USERS_INVITATIONS:
			return {
				...state,
				userInvitations: action.payload
			};
		case GET_USERS_EVENTS:
			return {
				...state,
				userEvents: action.payload
			};
		case GET_USERS_COMMITTEES:
				return {
					...state,
					userCommittees: action.payload
				};
		case GET_USER_COMMITTEE_DETAILS:
				return {
					...state,
					committeeDetails: action.payload
				};
		case SELECTED_COMMITTEE:
				return {
					...state,
					selectedUserCommittee: action.payload
				};
		case SELECTED_MEMBER:
				return {
					...state,
					selectedMember: action.payload
				};
		case SELECTED_ORGANIZATION:
				return {
					...state,
					selectedOrganization: action.payload
				};
		case CANCEL_MEMBERSHIP_SUBSCRIPTION_REQUEST:
				return {
					...state,
					cancelAutoRenew: true
				};
		case CANCEL_MEMBERSHIP_SUBSCRIPTION_SUCCESS:
				return {
					...state,
					cancelAutoRenew: false
				};
		default:
			return state;
	}
};
